import React, { Component, Fragment, useState } from "react";
// import { Animate, AnimateKeyframes, AnimateGroup } from "react-simple-animate";

// Map関連
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Markers,
  Marker,
} from "react-simple-maps";

import world from "./Static/world-50m.json";

const SdgsMap = ({
  data,
  valueColor,
  category,
  animation,
  setFilterCountry,
}) => {
  const color = valueColor + "66";
  const outline = "solid " + valueColor + " 1px";
  // coef=coefficient=係数
  let coef = 0;
  if (category == "businesses") {
    coef = 0.1;
  } else if (category == "business_cost") {
    coef = 0.00000002;
  } else if (category == "beneficiaries") {
    coef = 0.000002;
  } else if (category == "workers") {
    coef = 0.02;
  }

  return (
    <>
      <ComposableMap
        projectionConfig={{
          scale: 160,
          rotation: [-11, 0, 0],
        }}
        style={{
          width: "100%",
          height: "auto",
        }}
      >
        <ZoomableGroup center={[0, 20]} disablePanning>
          <Geographies geography={world}>
            {(geographies, projection) =>
              geographies.map(
                (geography, i) =>
                  geography.id !== "ATA" && (
                    <Geography
                      key={i}
                      geography={geography}
                      projection={projection}
                      style={{
                        default: {
                          fill: "#e9ecef",
                          stroke: "#607d8bd4",
                          strokeWidth: 0.2,
                          outline: "none",
                        },
                        hover: {
                          fill: "#e9ecef",
                          stroke: "#607d8bd4",
                          strokeWidth: 0.2,
                          outline: "none",
                        },
                        pressed: {
                          fill: "#e9ecef",
                          outline: "none",
                        },
                      }}
                    />
                  )
              )
            }
          </Geographies>

          <Markers>
            {data.allCountries.edges.map((marker, i) => (
              <Marker
                key={i}
                marker={{
                  coordinates: [marker.node.longitude, marker.node.latitude],
                }}
                style={{
                  default: {
                    fill: color,
                    outline: outline,
                    borderRadius: "180px",
                  },
                  hover: { fill: valueColor },
                  pressed: { fill: valueColor },
                }}
              >
                <circle
                  cx={0}
                  cy={0}
                  duration={10}
                  r={JSON.parse(marker.node.overview)[category] * coef}
                  style={{
                    stroke: marker.node.color,
                    strokeWidth: 3,
                    transform: "scale(1.2)",
                  }}
                  className={animation ? "mapAnime" : ""}
                  onClick={() => setFilterCountry(marker.node.id)}
                />
              </Marker>
            ))}
          </Markers>
        </ZoomableGroup>
      </ComposableMap>
    </>
  );
};

export default SdgsMap;
